// extracted by mini-css-extract-plugin
export default {"news":"news_news__KdDJq","subscribe-cta":"news_subscribe-cta__YJKVu","source":"news_source__MswaU"};